// src/components/AttendanceDashboard.js
import React from "react";
import {
  Box,
  CssBaseline,
  Toolbar,
  AppBar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Card,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AttendanceFilters from "./AttendanceFilters";
import AttendanceTable from "./AttendanceTable";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
const drawerWidth = 240;

function AttendanceDashboard() {
  return (
    // <Box sx={{ display: 'flex' }}>

    //   <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
    //     <Toolbar />
    //     <Typography variant="h4" gutterBottom>Attendance</Typography>
    //     <AttendanceFilters />
    //     <AttendanceTable />
    //   </Box>
    // </Box>
    <DashboardLayout>
      <Card sx={{maxHeight:"max-content",minHeight:"500px",paddingBottom:"30px"}}>
        <AttendanceFilters />
        <AttendanceTable />
      </Card>
    </DashboardLayout>
  );
}

export default AttendanceDashboard;
